import React, { useState } from "react";
import "./style.sass";
import { ImportPopup } from "./import-popup";
import { ChoosePopup } from "./choose-popup";
import { ImportedQuestionsModal } from "./imported-questions-modal";
import { SuccessModal } from "./success-modal";
import { CreatedTestsTable } from "./created-tests-table";
import { TestDetailsModal } from "./test-details-modal";

const QuestionBank = () => {
  const [viewMode, setViewMode] = useState("overview"); // 'overview' | 'created_tests'
  const [showImport, setShowImport] = useState(false);
  const [showChoose, setShowChoose] = useState(false);
  const [showImportedQuestions, setShowImportedQuestions] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [activeTestName, setActiveTestName] = useState("NEET Biology Mock Test–01");
  const [activeLevel, setActiveLevel] = useState("");
  const [selectedExam, setSelectedExam] = useState("NEET");
  const [selectedSubject, setSelectedSubject] = useState("Biology");
  const [selectedTestDetails, setSelectedTestDetails] = useState(null);

  const [isImportFlow, setIsImportFlow] = useState(false);

  const handleUploadSuccess = (rows, metadata = {}) => {
    if (metadata.testName) {
      setActiveTestName(metadata.testName);
    }
    if (metadata.level) {
      setActiveLevel(metadata.level);
    }
    setShowImport(false);
    setIsImportFlow(true);
    setShowImportedQuestions(true);
  };

  const [chooseParams, setChooseParams] = useState(null);

  const handleChooseProceed = (params = {}) => {
    const { testName, exam, subject } = params;
    if (testName) setActiveTestName(testName);
    if (exam) setSelectedExam(exam);
    if (subject) setSelectedSubject(subject);
    setChooseParams(params);
    setShowChoose(false);
    setIsImportFlow(false);
    setShowImportedQuestions(true);
  };

  const handleCompleteQuestionPaper = () => {
    setShowImportedQuestions(false);
    setShowSuccess(true);
  };

  return (
    <div className="question_bank_container">
      {/* Top Header */}
      <div className="qb_header">
        <div className="header_left">
          <h1>Question Papers</h1>
          <p>Manage and organize your question banks</p>
        </div>

        <div className="header_actions">
          {viewMode === "created_tests" && (
            <button
              className="back_overview_btn"
              onClick={() => setViewMode("overview")}
            >
              ← Back to Creation Options
            </button>
          )}
        </div>
      </div>

      {/* Overview Mode */}
      {viewMode === "overview" && (
        <div className="creation_overview">
          <h2 className="section_subtitle">Choose how you want to create question paper</h2>

          <div className="cards_grid">
            {/* Card 1: Choose from existing questions */}
            <div className="create_card">
              <div className="card_banner green_bg">
                <div className="graphic_mockup">
                  <div className="mock_line header_line_green"></div>
                  <div className="mock_line"></div>
                  <div className="mock_line"></div>
                  <div className="mock_line short"></div>

                  <div className="banner_badge green">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                    </svg>
                  </div>
                </div>
              </div>

              <div className="card_content">
                <h3>Choose Questions</h3>
                <p className="card_desc">
                  Select questions from the pool of 45000+ AI generated questions.
                </p>

                <div className="divider"></div>

                <ul className="checklist">
                  <li>
                    <div className="check_icon green">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </div>
                    Select questions from the question bank
                  </li>
                  <li>
                    <div className="check_icon green">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </div>
                    Organize by question type
                  </li>
                  <li>
                    <div className="check_icon green">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </div>
                    Select questions
                  </li>
                  <li>
                    <div className="check_icon green">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </div>
                    Assign to test
                  </li>
                  <li>
                    <div className="check_icon green">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </div>
                    Publish questions to students
                  </li>
                </ul>

                <button
                  className="card_action_btn green_btn"
                  onClick={() => setShowChoose(true)}
                >
                  Choose Questions →
                </button>
              </div>
            </div>

            {/* Card 2: Bring your own questions */}
            <div className="create_card">
              <div className="card_banner purple_bg">
                <div className="graphic_mockup">
                  <div className="mock_line header_line_purple"></div>
                  <div className="mock_line"></div>
                  <div className="mock_line"></div>
                  <div className="mock_line short"></div>

                  <div className="banner_badge purple">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                      <polyline points="17 8 12 3 7 8"/>
                      <line x1="12" y1="3" x2="12" y2="15"/>
                    </svg>
                  </div>
                </div>
              </div>

              <div className="card_content">
                <h3>Bring your own questions</h3>
                <p className="card_desc">
                  Upload your set of questions to choose from.
                </p>

                <div className="divider"></div>

                <ul className="checklist">
                  <li>
                    <div className="check_icon purple">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </div>
                    Upload questions from your PDF
                  </li>
                  <li>
                    <div className="check_icon purple">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </div>
                    Organize by question type
                  </li>
                  <li>
                    <div className="check_icon purple">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </div>
                    Select questions
                  </li>
                  <li>
                    <div className="check_icon purple">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </div>
                    Assign to test
                  </li>
                  <li>
                    <div className="check_icon purple">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </div>
                    Publish questions to students
                  </li>
                </ul>

                <button
                  className="card_action_btn purple_btn"
                  onClick={() => setShowImport(true)}
                >
                  Upload Questions →
                </button>
              </div>
            </div>
          </div>

          {/* Bottom Card: View created question papers */}
          <div className="created_papers_banner">
            <div className="banner_left">
              <div className="banner_icon_badge">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                  <polyline points="14 2 14 8 20 8"/>
                  <line x1="16" y1="13" x2="8" y2="13"/>
                  <line x1="16" y1="17" x2="8" y2="17"/>
                </svg>
              </div>
              <div className="banner_text">
                <h4>View created question papers</h4>
                <p>Access and manage all the question papers you have created</p>
              </div>
            </div>

            <button
              className="view_papers_btn"
              onClick={() => setViewMode("created_tests")}
            >
              View Created Question Papers →
            </button>
          </div>
        </div>
      )}

      {/* Created Test Table View Mode */}
      {viewMode === "created_tests" && (
        <CreatedTestsTable onSelectTest={(test) => setSelectedTestDetails(test)} />
      )}

      {/* Modals & Overlays */}
      {showChoose && (
        <ChoosePopup
          onClose={() => setShowChoose(false)}
          onProceed={handleChooseProceed}
        />
      )}

      {showImport && (
        <ImportPopup
          onClose={() => setShowImport(false)}
          onUploadSuccess={handleUploadSuccess}
        />
      )}

      {showImportedQuestions && (
        <ImportedQuestionsModal
          testName={activeTestName}
          exam={selectedExam}
          subject={selectedSubject}
          level={activeLevel || chooseParams?.level || chooseParams?.difficulty || ""}
          isImportFlow={isImportFlow}
          chooseParams={chooseParams}
          onClose={() => setShowImportedQuestions(false)}
          onComplete={handleCompleteQuestionPaper}
        />
      )}

      {showSuccess && (
        <SuccessModal
          testName={activeTestName}
          onClose={() => setShowSuccess(false)}
          onGoToQuestionPapers={() => setViewMode("created_tests")}
        />
      )}

      {selectedTestDetails && (
        <TestDetailsModal
          test={selectedTestDetails}
          onClose={() => setSelectedTestDetails(null)}
        />
      )}
    </div>
  );
};

export default QuestionBank;
